export default __webpack_public_path__ + "firstCarouselItem.f2dce7626c7a0024670d615aa09452ea.png";